import moment from "moment";

const ISOToDateTimeFormat = (inputVal: string): string => {
  const date = moment.utc(inputVal, "YYYY-MM-DDTHH:mm:ss"); // Parse as UTC without offset
  const formattedDate = date.format("DD MMM, YYYY h:mm A");
  return formattedDate;
};

export default ISOToDateTimeFormat;
